import { createContext, useContext } from 'react';

export const GameContext = createContext(null);

export function useGame() {
  const ctx = useContext(GameContext);
  if (ctx == null) {
    throw new Error('useGame must be used within a GameContext.Provider');
  }
  return ctx;
}
